/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu-burger': {
    width: 48,
    height: 48,
    viewBox: '0 0 24 24',
    data: '<path pid="0" style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal" d="M2 5v2h20V5H2zm0 6v2h20v-2H2zm0 6v2h20v-2H2z" font-weight="400" font-family="sans-serif" white-space="normal" overflow="visible"/>'
  }
})
